import React, { useEffect, useRef, useState } from "react";
import "./blogdetail.css";

import { Link, useParams } from "react-router-dom";
import blog3 from "./assets/images/Blog3.png";
import noimage from "./assets/images/noimage.webp";

export default function BlogDetail() {
    const [headings, setHeadings] = useState([]);
  const [active, setActive] = useState(null);
  const { title } = useParams();
  const [blogDetail, setBlogDetail] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const answerRefs = useRef([]);

  const toggleFAQ = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const slugify = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

useEffect(() => {

  if (!blogDetail) return;

  const timer = setTimeout(() => {

    const headingElements = Array.from(
      document.querySelectorAll(".content h2, .content h3, .content h4")
    );

    const headingData = headingElements.map((heading, index) => {

      const id = heading.innerText
        .toLowerCase()
        .replaceAll(" ", "_");

      heading.setAttribute("id", id);

      return {
        id,
        text: heading.innerText,
        level: heading.tagName,
        element: heading,
        index
      };

    });

    setHeadings(headingData);

    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            const index = headingElements.indexOf(entry.target);
            setActive(index);

          }

        });

      },
      {
        rootMargin: "-30px 0% -77%",
        threshold: 1
      }
    );

    headingElements.forEach((h) => observer.observe(h));

  }, 100); // delay for DOM render

  return () => clearTimeout(timer);

}, [blogDetail]);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await fetch("https://rbuymart.rbhardwaj.com/server/api/admin/blog.php");
        const data = await res.json();

        const blog = data.data.find(
          (p) => slugify(p.title) === decodeURIComponent(title),
        );

        console.log(blog);

        setBlogDetail(blog || null);

     
        if (window.prerenderReady !== undefined) {
          window.prerenderReady = true;
        }
      } catch (error) {
        console.error("Error fetching blog:", error);

        if (window.prerenderReady !== undefined) {
          window.prerenderReady = true;
        }
      }
    };

    fetchBlog();
  }, [title]);


  if (!blogDetail) return <p>Loading...</p>;

  // Safe FAQ access
  const faqData = blogDetail?.faq ? JSON.parse(blogDetail.faq) : [];
console.log(JSON.parse(blogDetail.faq));


const scrollToHeading = (index) => {

  headings[index]?.element?.scrollIntoView({
    behavior: "smooth",
    block: "center"
  });

};
  return (
    <>


      <div
        className="blog-detail-page"
        style={{ maxWidth: "1300px", margin: "0 auto" }}
      >
        <div className="sidebar">
          <h2 className="sidebar-title">Wellness Hub</h2>

          <div className="nav-section">
            <Link
              to="/blog"
              className="nav-item"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <i class="material-icons" style={{ color: "white" }}>
                &#xe88a;
              </i>{" "}
              Home
            </Link>
          </div>

        

         
          <aside className="nav-section nav-section" >
            <ul>
              {headings.map((h, i) => {
                let indent = 0;
                let font =16;
             if (h.level === "H2") {
  indent = 0;
  font = 16;
}
             if (h.level === "H3") {
  indent = 15;
  font = 14;
}

if (h.level === "H4") {
  indent = 30;
  font = 12;
}

                return (
                  <li key={h.id} style={{ marginLeft: indent, fontSize:font }} className={`nav-item toc-link ${active === i ? "active" : ""}`}
                      onClick={() => scrollToHeading(i)}>
                     <i class="material-icons">&#xe85d;</i>
                    <span
                   
                    >
                      {h.text}
                    </span>
                  </li>
                );
              })}
            </ul>
          </aside>
        </div>
        <div className="blog-detail-contant">
          <h1 style={{ fontWeight: "500" }}>{blogDetail.title}</h1>

          <div class="datediv">
            <div>
              <p style={{ color: "#126cc5", fontSize: "25px" }}>
                {blogDetail.author}
              </p>
              Posted on {blogDetail.date}
            </div>

            <div>
              <button
                style={{
                  padding: "10px 12px",
                  borderRadius: "100%",
                  border: "none",
                  background: "#37373716",
                }}
                onClick={() => {
                  const pagelink = {
                    title: blogDetail.title,
                    text: "Check out this page!",
                    url: window.location.href,
                  };

                  if (navigator.share) {
                    navigator
                      .share(pagelink)
                      .then(() => console.log("Shared successfully"))
                      .catch((err) => console.log("Share failed:", err));
                  } else {
                    alert("Web Share API not supported!");
                  }
                }}
              >
                <i class="material-icons">&#xe80d;</i>
              </button>
            </div>
          </div>

          <div className="blog-details-hero">
            <img
              src={blogDetail.image || noimage}
              alt={blogDetail.title}
              width={818}
              height={500}
            />
          </div>

          <div className="content">
            <div dangerouslySetInnerHTML={{ __html: blogDetail.content }} />
          </div>

          {/* FAQ Section */}
          {faqData.length > 0 && (
            <div className="section-div">
              <div className="faq-left section-heading">
                <h2>
                  Frequently Asked Questions
                
                </h2>
              </div>

              {faqData.map((item, index) => (
                <div className="faq-item" key={index}>
                  <div
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div style={{ display: "flex" }}>
                      <h4 style={{ width: "30px" }}>{index + 1}. </h4>
                      <span>{item.question}</span>
                    </div>

                    <span
                      className={`icon ${openIndex === index ? "rotate" : ""}`}
                    >
                      +
                    </span>
                  </div>

                  <div
                    className={`faq-answer ${openIndex === index ? "open" : ""}`}
                    ref={(el) => (answerRefs.current[index] = el)}
                    style={{
                      maxHeight:
                        openIndex === index && answerRefs.current[index]
                          ? `${answerRefs.current[index].scrollHeight}0px`
                          : "0px",
                      overflow: "hidden",
                      transition: "max-height 0.4s ease",
                    }}
                  >
                   <b>Ans. </b> {item.answer}
                    <br />
                    <br />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
